import { render } from "./ProfileStatus.vue?vue&type=template&id=ecf2ecec&scoped=true"
import script from "./ProfileStatus.vue?vue&type=script&lang=js"
export * from "./ProfileStatus.vue?vue&type=script&lang=js"

import "./ProfileStatus.vue?vue&type=style&index=0&id=ecf2ecec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf2ecec"]])

export default __exports__